import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'sushiweb/Layout';
import H5 from 'sushiweb/Typography/Heading/H5';
import InputContainer from '../InputContainer';
import { FormWrapper } from '../styles';
import TextareaContainer from '../TextContainer';

const CompanyProfile = ({ contactDetails, legalDetails }) => {
  const { company_name: companyName = '', gstin = '', pan = '' } = legalDetails;
  const {
    contact_no: contactNo = '',
    contact_person: contactPerson = '',
    email_id: email = '',
    registered_address: address = '',
  } = contactDetails;

  const disable = true;
  return (
    <>
      <FormWrapper>
        <H5>Company Legal Details</H5>
        <Layout gap={30}>
          <Layout.Item colD={4} colT={4} colM={6}>
            <InputContainer
              parameter='Company Name'
              label='Name'
              value={companyName}
              disabled={disable}
            />
          </Layout.Item>
          <Layout.Item colD={4} colT={4} colM={6}>
            <InputContainer
              parameter='GSTIN'
              label='GSTIN'
              value={gstin}
              disabled={disable}
            />
          </Layout.Item>
          <Layout.Item colD={4} colT={4} colM={6}>
            <InputContainer
              parameter='PAN No.'
              label='Pan No.'
              value={pan}
              disabled={disable}
            />
          </Layout.Item>
        </Layout>
        <H5>Company Contact Details</H5>
        <Layout gap={30}>
          <Layout.Item colD={4} colT={4} colM={6}>
            <InputContainer
              parameter='Company Contact Person'
              label='Name'
              value={contactPerson}
              disabled={disable}
            />
          </Layout.Item>
          <Layout.Item colD={4} colT={4} colM={6}>
            <InputContainer
              parameter='Email ID'
              label='Email ID'
              value={email}
              disabled={disable}
            />
          </Layout.Item>
          <Layout.Item colD={4} colT={4} colM={6}>
            <InputContainer
              parameter='Contact No.'
              label='Contact No'
              value={contactNo}
              disabled={disable}
            />
          </Layout.Item>
        </Layout>
        <TextareaContainer
          large
          parameter='Registered Address'
          label='Address'
          value={address}
          disabled={disable}
        />
      </FormWrapper>
    </>
  );
};

CompanyProfile.propTypes = {
  contactDetails: PropTypes.objectOf(PropTypes.any).isRequired,
  legalDetails: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default CompanyProfile;
